import React from 'react';
import Form from './Form/Form';
import I18n from './I18n';
import 'rctui/styles/reset.scss';
import LiquidChrome from './LiquidChrome';

class AuthForm extends React.Component {
  formItems = [
    {
      label: "user.field.Login",
      name: "login",
      type: "numeric",
      placeholder: "Enter your username",
      autoComplete: "username",
      inputMode: "numeric",
      value: ''
    },
    {
      label: "user.field.Password",
      name: "password",
      type: "password",
      placeholder: "Enter your password",
      autoComplete: "current-password",
      value: ""
    },
    {
      name: "company",
      type: "hidden",
      value: document.body.dataset.company
    }
  ];

  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      values: {},
      errors: [],
      company: ''
    };
  }

  componentDidMount() {
    localStorage.removeItem('currentComponent');
    this.setState({ company: document.body.dataset.company || '' });
  }

  handleSubmit = () => {
    this.setState({
      disabled: true
    });

    let company = this.state.values.company;
    if (company == null || company === '') {
      company = document.body.dataset.company || this.state.company || '';
    }

    let values = Object.assign({}, this.state.values, {
      company: company
    });

    this.setState({
      values: {}
    });

    $.post('/login', values, (r) => {
      // Log auth errors to the console in the browser (no global logger available client-side)
      if (r.errors) {
        this.setState({
          errors: r.errors
        });
      } else {
        location.href = r.url;
      }
      this.setState({
        disabled: false
      });
    });
    return false;
  };

  render() {
    return (
      <><LiquidChrome
        baseColor={[0.075, 0.059, 0.012]}
        speed={0.2}
        amplitude={0.3}
        frequencyX={3}
        frequencyY={3}
        interactive={true}
      />
      <div className="authContainer authContainerDc">
        <div className="authBrand">
          <img src={'/img/logo_new.png'} className="admin_login_logo" alt="WTrader"/>
        </div>
        <div className="authInnerBox">
          <div className="authWelcome">
            {/* <span className="authEyebrow"><I18n message="authorization.title"/></span> */}
            <h1>Welcome Back</h1>
            <p>Sign in to manage your trading platform.</p>
          </div>
          <Form onSubmit={this.handleSubmit}
                errors={this.state.errors}
                submitText="button.enter"
                disabled={this.state.disabled}
                items={this.formItems}
                values={this.state.values}
          />
        </div>
        <div className="authFooter">
          {/* <span className="authSecurityDot"/> */}
          <svg
  viewBox="0 0 24 24"
  width={16}
  height={16}
  fill="none"
  stroke="currentColor"
  strokeWidth={1.8}
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <rect x="3" y="11" width="18" height="11" rx="2" />
  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
</svg>
          Secure administrator access
        </div>
      </div>
      </>
    );
  }
}

export default AuthForm;



// WEBPACK FOOTER //
// ./src/js/Component/AuthForm.jsx